import { Box } from "@mui/system";
import { Footer } from "components/common/Footer";
import { CourseItem } from "components/layout/CourseItem";
import { endPoints } from "const/endPoints";
import { fetchWithToken } from "helpers/fetch";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MyCourseItem } from "../../../components/layout/MyCourseItem";
import { MyCoursesContainer, ProfileCourseList } from "./styles";

export const MyCourses = () => {
  const [courses, setCourses] = useState([]);
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();
  console.log(courses);

  const getMyCourses = async () => {
    try {
      const response = await fetchWithToken(endPoints.get_courses_me);
      const courses = await response.json();
      
      // Verificar si courses es un array válido
      if (Array.isArray(courses)) {
        setCourses(courses);
      } else {
        // Si hay un error o el usuario no está autenticado
        setCourses([]);
      }
    } catch (error) {
      console.error('Error fetching courses:', error);
      setCourses([]);
    }
  };

  useEffect(() => {
    // Si no hay usuario autenticado, redirigir
    if (!user) {
      navigate('/access');
      return;
    }
    getMyCourses();
  }, [user, navigate]);

  // Si no hay usuario, no renderizar nada
  if (!user) {
    return null;
  }

  if (!Array.isArray(courses) || courses.length === 0) {
    return (
      <Box
        sx={{
          height: "calc(100vh - 300px)",
          "& > h1": {
            textAlign: "center",
            marginTop: "50px",
            color: "#a0a0a0",
          },
        }}
      >
        <h1>No tienes cursos adquiridos aún</h1>;
      </Box>
    );
  }

  return (
    <>
      <h1>Cursos adquiridos</h1>
      <ProfileCourseList>
        {Array.isArray(courses) && courses.map((course) => {
          const { id, title, price, numberOfStudents, duration, level } =
            course;
          return (
            <CourseItem
              key={course.id}
              title={title}
              price={price}
              numberOfStudents={numberOfStudents}
              duration={duration}
              level={level}
              id={id}
              backgroundColor="#fff"
              image={course.image}
            />
          );
        })}
      </ProfileCourseList>
    </>
  );
};
